class JsUtil{
    constructor(opts){
        this.opts = $.extend(true, {
            msgCallBack(){

            },
            confirmCallBack(){

            },
            cancelCallBack(){

            }
        }, opts);
    };

    message(text, str){
        promokit.message({
            type:'alert',
            message:text,
            done:()=> {
                if(!this.msgCallBack) return;
                this.msgCallBack(str);
            }
        });
    };

    confirm(text, str){
        promokit.message({
            type:'confirm',
            message:text,
            done:()=> {
                if(!this.confirmCallBack) return;
                this.confirmCallBack(str, "confirm");
            },
            cancel:()=> {
                if(!this.confirmCallBack) return;
                this.confirmCallBack(str, "cancel");
            }
        });
    };

    status(selector, value){
        switch (value) {
            case 'disabled':
                $(selector).removeClass('complete');
                $(selector).addClass('disabled');
                break;
            case 'complete':
                $(selector).removeClass('disabled');
                $(selector).addClass('complete');
                break;
            case 'remove':
                $(selector).removeClass('disabled');
                $(selector).removeClass('complete');
                break;

        }
    };
};

export default JsUtil;